import { ArticleCommentsTopTabRenderProps } from "../articleCommentsTopTabWrapper"
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";
import { getTranslation } from "../translations"


interface ArticleCommentsTopTabUIMobileWebProps {
    props: ArticleCommentsTopTabRenderProps
}

export class ArticleCommentsTopTabMobileWebUI extends React.Component<ArticleCommentsTopTabUIMobileWebProps, {}>{
    private handleOnAddCommentBtnPress = () => {
        const { handleFormVisibility, handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
        handleFormVisibility()
    }

    render() {
        const { lang, numOfComments, isAddCommentFormVisible } = this.props.props

        return (
            <div className="ArticleCommentsTopTabUI">
                <div className="tabTitle">
                    <div className="tabIcon">
                        <div className="tabNumber">{getTalkbackNumberView(numOfComments.toString())}</div>
                    </div>
                    <div className="tabText">{getTranslation(lang, "Comments")}</div>
                </div>
                <div className="tabPanel">
                    {!isAddCommentFormVisible &&
                        <button
                            key="newCommentBtn"
                            className="newCommentBtn"
                            title={getTranslation(lang, "New Comment")}
                            disabled={isAddCommentFormVisible}
                            onClick={this.handleOnAddCommentBtnPress}>
                            <div className="btnText">{getTranslation(lang, "New Comment")}</div>
                        </button>
                    }
                </div>
            </div >
        )
    }
}